// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { createFileRoute } from "@tanstack/react-router";
import { NotFound } from "@/components/shared/not-found";

// Catch-all: any URL no other route claims lands here, inside the authenticated shell (and its auth guard).
export const Route = createFileRoute("/_authenticated/$")({
  component: NotFound,
});
